module.exports = __webpack_public_path__ + "media/standardized_tests/quote-e00a0bdf.gif";